export default function Footer() {
  return (
    <footer
      className="border-t-2 border-black mt-16 bg-[#1a1a19] text-[#f6f4f0]"
      data-testid="site-footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <h3 className="serif text-3xl mb-2">The Couponer</h3>
          <p className="text-xs tracking-wide opacity-80 leading-relaxed">
            An almanac of every worthwhile promo, printable, and in-store deal —
            curated for the modern clipper.
          </p>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.2em] mb-3 opacity-60">SECTIONS</h4>
          <ul className="space-y-1 text-sm">
            <li>· Feed</li>
            <li>· Stores</li>
            <li>· Saved</li>
            <li>· Submit a deal</li>
            <li className="pt-2">
              · <a href="/about" className="underline hover:no-underline">About</a>
            </li>
            <li>
              · <a href="/contact" className="underline hover:no-underline">Contact</a>
            </li>
            <li>
              · <a href="/privacy" className="underline hover:no-underline">Privacy</a>
            </li>
            <li>
              · <a href="/terms" className="underline hover:no-underline">Terms of Service</a>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.2em] mb-3 opacity-60">DISCLAIMER</h4>
          <p className="text-xs opacity-70 leading-relaxed">
            Prices and offers change. Verify at the retailer before checkout. We
            may earn a small referral fee on some outbound links.
          </p>
        </div>
      </div>
      <div className="border-t border-white/20 py-4 px-6 md:px-10 text-[10px] tracking-[0.2em] opacity-60 flex justify-between">
        <span>EST. 2026 · US EDITION</span>
        <span>ISSUE №{new Date().getFullYear()}</span>
      </div>
    </footer>
  );
}
